/*
  Rail horizontal glissable — module PARTAGE.

  Deux consommateurs a ce jour : la bande de marques de l'accueil
  (sections/marques-reconditionnees.liquid) et le carrousel d'avis Trustpilot
  (snippets/trustpilot-reviews.liquid). Extrait le 2026-09-22 d'un code qui etait
  specifique aux marques : la logique porte trois pieges couteux (capture paresseuse du
  pointeur, avalage de clic, garde clavier) et une deuxieme copie aurait garanti qu'une
  correction future n'atteigne qu'un seul des deux rails.

  CONTRAT. Le conteneur porte `data-drag-rail`, la piste qui defile porte
  `data-drag-track`. Le module pose sur le CONTENEUR les classes `has-overflow`,
  `can-scroll-left` et `can-scroll-right` — c'est au CSS de chaque composant d'en faire
  ce qu'il veut (fondus de bord, fleches...). Il pose `is-dragging` sur la PISTE pendant
  le geste. Les elements qu'un glisser ne doit pas activer portent `data-drag-item`.

  Ce module ne pilote AUCUN defilement automatique : la piste defile nativement, meme JS
  coupe. Il n'ajoute que l'affordance souris et les classes d'etat. Degradation : sans
  lui, pas de fondus ni de glisser, le rail reste utilisable au doigt et a la molette
  horizontale.
*/

(function () {
  var THRESHOLD = 5;
  // Au-dela de ce deplacement, on a glisse — pas clique. 5px est le seuil usuel d'un
  // tremblement de souris ; en dessous, le lien doit s'ouvrir normalement.
  var DRAG_SLOP = 5;
  var resizeTicking = false;

  function update(rail, track) {
    var hasOverflow = track.scrollWidth > track.clientWidth + THRESHOLD;
    rail.classList.toggle('has-overflow', hasOverflow);
    rail.classList.toggle('can-scroll-left', hasOverflow && track.scrollLeft > THRESHOLD);
    rail.classList.toggle(
      'can-scroll-right',
      hasOverflow && track.scrollLeft + track.clientWidth < track.scrollWidth - THRESHOLD,
    );
  }

  // Revele les fondus quand la piste defile. Une seule mesure par frame.
  function bindScroll(rail, track) {
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        update(rail, track);
        ticking = false;
      });
    });
  }

  // DESKTOP : le rail deborde mais rien ne permet de le parcourir a la souris. Mesure du
  // 2026-09-22 a 945px de large : scrollWidth 2652 pour un clientWidth de 850, donc 1802px
  // inatteignables — la molette scrolle la PAGE, il n'y a pas de fleche, et
  // `scrollbar-width: none` retire le dernier indice. D'ou le glisser, souris UNIQUEMENT :
  // le tactile scrolle deja nativement et lui prendre le geste couterait l'inertie du
  // navigateur (anti-pattern n°14, corollaire du zoom custom qui remplace un geste natif).
  function bindDrag(track) {
    // Les <img> ET LES TUILES sont rendues non deplacables. Les images ne suffisent PAS :
    // un `<a href>` est lui aussi nativement deplacable, et presser une tuile puis bouger
    // demarre le glisser-de-lien du navigateur, qui emet `pointercancel` et tue le geste.
    // Symptome vecu (2026-09-22) : « je suis oblige de mettre ma souris ENTRE les images »
    // — les seuls endroits sans lien etaient le `gap` et le `padding` de la piste.
    Array.prototype.forEach.call(track.querySelectorAll('img, a, [data-drag-item]'), function (el) {
      el.draggable = false;
    });

    var drag = null;
    var swallowClick = false;

    track.addEventListener('pointerdown', function (e) {
      swallowClick = false;
      if (e.pointerType !== 'mouse') return;
      if (e.button !== 0) return;
      drag = { x: e.clientX, left: track.scrollLeft, moved: 0, id: e.pointerId, captured: false };
      track.classList.add('is-dragging');
    });

    track.addEventListener('pointermove', function (e) {
      if (drag === null) return;
      var dx = e.clientX - drag.x;
      var abs = dx < 0 ? -dx : dx;
      if (abs > drag.moved) drag.moved = abs;

      // CAPTURE PARESSEUSE — et surtout PAS au `pointerdown`.
      // La capture redirige vers l'element capteur non seulement les evenements pointeur,
      // mais aussi le `click` qui suit. Posee des le `pointerdown`, elle faisait arriver le
      // clic sur la PISTE au lieu du <a> : plus aucune tuile n'etait cliquable, et le
      // delegue de tracking ne poussait rien non plus. Mesure du 2026-09-22, trace d'un vrai
      // clic souris : pointerdown sur le logo d'une tuile, puis pointerup ET click sur
      // la PISTE, et `closest('a')` depuis cette cible ne trouvait plus le lien.
      // ⚠️ Un PointerEvent SYNTHETIQUE n'etablit pas de capture reelle : aucun test
      // `dispatchEvent` ne peut voir ce bug. Il faut un vrai clic du navigateur.
      // En capturant seulement une fois le seuil franchi, un clic net ne capture jamais et
      // le lien fonctionne ; un vrai glisser capture et survit a la sortie de piste, son
      // clic etant de toute facon avale.
      if (drag.captured === false && drag.moved > DRAG_SLOP && track.setPointerCapture) {
        try {
          track.setPointerCapture(drag.id);
          drag.captured = true;
        } catch (err) {
          /* capture refusee : on retombe sur le comportement sans capture */
        }
      }

      // Une seule ecriture par evenement, aucune transition en jeu sur scrollLeft : le geste
      // continu se peint directement (anti-pattern n°14).
      track.scrollLeft = drag.left - dx;
    });

    function endDrag() {
      if (drag === null) return;
      // On n'avale le clic que si le rail a REELLEMENT defile. Se fier a la seule distance
      // du curseur tue des liens : rail qui ne deborde pas (3 marques = 654px pour 1340
      // disponibles), ou geste en butee — dans les deux cas rien ne bouge a l'ecran et
      // pourtant un clic tremble de 6px annulait le lien.
      swallowClick = drag.moved > DRAG_SLOP && track.scrollLeft !== drag.left;
      if (drag.captured && track.releasePointerCapture && track.hasPointerCapture(drag.id)) {
        track.releasePointerCapture(drag.id);
      }
      drag = null;
      track.classList.remove('is-dragging');
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    // Relacher un glisser ne doit PAS suivre la tuile sous le curseur.
    track.addEventListener(
      'click',
      function (e) {
        // Une activation CLAVIER (Tab + Entree) a `detail === 0` et ne doit jamais etre
        // avalee. La capture rend le drapeau difficile a laisser arme, mais un
        // `pointercancel` (geste interrompu par le systeme, bascule d'onglet, capture
        // perdue) suffit encore a le poser sans qu'aucun clic souris ne vienne le
        // consommer. Sans cette garde, la tuile activee au clavier n'ouvrirait pas son lien
        // ET ne pousserait pas `click_cta`. On le DESARME au passage.
        if (e.detail === 0) {
          swallowClick = false;
          return;
        }
        if (swallowClick === false) return;
        swallowClick = false;
        e.preventDefault();
        e.stopPropagation();
      },
      true,
    );
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-drag-rail]'), function (rail) {
      if (rail.dataset.dragRailBound === '1') return;
      var track = rail.querySelector('[data-drag-track]');
      if (!track) return;
      rail.dataset.dragRailBound = '1';
      bindScroll(rail, track);
      bindDrag(track);
      requestAnimationFrame(function () {
        update(rail, track);
      });
    });
  }

  // Le redimensionnement re-interroge le DOM au lieu de tenir une liste de paires : une
  // liste survit mal a un re-rendu de section (noeuds detaches, nouveaux noeuds absents),
  // et le cout d'un querySelectorAll sur une poignee de rails, deja limite a une frame,
  // est negligeable devant le bug qu'il supprime.
  function updateAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-drag-rail]'), function (rail) {
      var track = rail.querySelector('[data-drag-track]');
      if (track) update(rail, track);
    });
  }

  // Les ecouteurs GLOBAUX ne se posent qu'une fois ; `init`, lui, se rejoue a chaque
  // execution du script. Mesure du 2026-09-22 : avec un verrou global place en tete, un
  // re-rendu de la section (live-reload de `shopify theme dev`, qui n'emet PAS
  // `shopify:section:load`) laissait le nouveau rail sans `data-drag-rail-bound`, donc sans
  // fondus ni curseur `grab`, jusqu'au rechargement complet.
  if (!window.__mintDragRailInit) {
    window.__mintDragRailInit = true;

    window.addEventListener('resize', function () {
      if (resizeTicking) return;
      resizeTicking = true;
      requestAnimationFrame(function () {
        updateAll();
        resizeTicking = false;
      });
    });

    document.addEventListener('shopify:section:load', function (e) {
      requestAnimationFrame(function () {
        init(e.target);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }
})();
